import { useCallback } from 'react';

import useCustomFloating from '@ecp/common/src/components/unstyled/floating/useCustomFloating';

const useAutocomplete = ({ open: openProp, placement, handleItemClick, setValue }) => {
  const { open, setOpen, refs, getReferenceProps, floatingPosition, positionStrategy } = useCustomFloating({
    openProp,
    placement,
    closeWhenOutside: true,
  });

  const onItemClick = useCallback(
    (itemLabel, itemUrl) => {
      handleItemClick?.(itemLabel, itemUrl);
      setValue?.(itemLabel);
      setOpen(false);
    },
    [handleItemClick, setOpen, setValue]
  );
  return {
    open,
    setOpen,
    refs,
    getReferenceProps,
    floatingPosition,
    positionStrategy,
    onItemClick,
  };
};

export default useAutocomplete;
